




































import { Component, Vue, Prop } from "vue-property-decorator";
import { Toast } from "vant";

@Component
export default class ActivityIndicator extends Vue {
  @Prop({ type: Function, required: false }) private onRefresh!: boolean;
  private refreshObj: any = {
    defaultOffset: 50, // 默认高度.releshMoudle的margin-top和.down-tip, .up-tip, .refresh-tip的height
    top: 0,
    scrollIsToTop: 0,
    startY: 0,
    isDropDown: false, // 是否下拉
    isRefreshing: false, // 是否正在刷新
    dropDownState: 1, // 显示1:下拉可以刷新, 2:松开立即刷新, 3:正在刷新数据中...
    dropDownInfo: {
      downText: "下拉可以刷新",
      upText: "松开立即刷新",
      refreshText: "正在刷新数据...",
    },
  };
  private created() {
    if (document.querySelector(".down-tip")) {
      this.refreshObj.defaultOffset =
        (document.querySelector(".down-tip") as any).clientHeight ||
        this.refreshObj.defaultOffset;
    }
  }
  private touchStart(e: any) {
    this.refreshObj.startY = e.targetTouches[0].pageY;
  }
  private touchMove(e: any) {
    this.refreshObj.scrollIsToTop =
      document.documentElement.scrollTop ||
      window.pageYOffset ||
      document.body.scrollTop;
    if (e.targetTouches[0].pageY > this.refreshObj.startY) {
      this.refreshObj.isDropDown = true;
      if (
        this.refreshObj.scrollIsToTop === 0 &&
        !this.refreshObj.isRefreshing
      ) {
        const diff =
          e.targetTouches[0].pageY -
          this.refreshObj.startY -
          this.refreshObj.scrollIsToTop;
        this.refreshObj.top =
          Math.pow(diff, 0.8) +
          (this.refreshObj.dropDownState === 3
            ? this.refreshObj.defaultOffset
            : 0);
        if (this.refreshObj.top >= this.refreshObj.defaultOffset) {
          this.refreshObj.dropDownState = 2;
          e.preventDefault();
        } else {
          this.refreshObj.dropDownState = 1;
          e.preventDefault();
        }
      }
    }
  }
  private touchEnd(e: any) {
    if (this.refreshObj.isDropDown && !this.refreshObj.isRefreshing) {
      if (this.refreshObj.top >= this.refreshObj.defaultOffset) {
        // do refresh
        this.refresh();
        this.refreshObj.isRefreshing = true;
      } else {
        // cancel refresh
        this.refreshObj.isRefreshing = false;
        this.refreshObj.isDropDown = false;
        this.refreshObj.dropDownState = 1;
        this.refreshObj.top = 0;
      }
    }
  }
  private refresh() {
    this.refreshObj.dropDownState = 2;
    this.refreshObj.top = this.refreshObj.defaultOffset;
    setTimeout(() => {
      this.refreshDone();
    }, 200000);
  }
  private refreshDone() {
    this.refreshObj.isRefreshing = false;
    this.refreshObj.isDropDown = false;
    this.refreshObj.dropDownState = 3;
    this.refreshObj.top = 0;
  }
}
